export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Mine',
  frontPageProvideTitle: 'Supply',
  frontPagePersonalCenterTitle: 'Profile',
  login: 'Login',
  home_chatWithOctopie: 'Understanding Your Thoughts',
  home_chatNeedUnderstood: 'Your Thoughts Are Understood',
  home_draftBannerTitle: 'Finish your message',
  home_draftBannerSubtitle: 'AI has your message ready — tap to continue',
  home_tabHome: 'Home',

  // App.vue
  appRequirementTitle: 'We value every suggestion and feedback',
  appRequirementBtn: 'Submit',
  appSubmitSuccess: 'Submitted successfully, thank you for your feedback',
  appFeedbackLink: 'Feedback/Suggestion',
  mobile_banner_text: 'For the best experience, use our app',
  mobile_banner_btn: 'Get App',

  // Common
  loading: 'Loading...',
  confirm: 'Confirm',
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  search: 'Search',
  refresh: 'Refresh',
  change_batch: 'Shuffle',
  back: 'Back',
  submit: 'Submit',
  close: 'Close',
  ok: 'OK',
  yes: 'Yes',
  no: 'No',
  send: 'Send',
  block: 'Block',
  more: 'More',
  logout: 'Logout',
  settings: 'Settings',
  view_guide: 'View Guide',
  feedback: 'Feedback',
  feedback_title: 'Feedback',
  feedback_new: 'New Feedback',
  feedback_empty: 'No feedback yet',
  feedback_hint: 'Tell us what you think...',
  feedback_submit: 'Submit',
  feedback_submit_success: 'Feedback submitted successfully',
  feedback_submit_failed: 'Failed to submit feedback',
  feedback_reply_label: 'Platform Reply',
  register: 'Register',
  name: 'Name',
  email: 'Email',
  mobile: 'Mobile',
  password: 'Password',
  verification_code: 'Verification Code',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'All Rights Reserved.',
  footerVersion: 'Version {version}',
  copy: 'Copy',
  regenerate: 'Regenerate',
  generate: 'Generate',
  contact_now: 'Chat',
  yours: 'yours',
  xiaoyao_analysis: "AI Analysis",
  brand_name: 'OctoSay',
  anonymous: 'Anonymous',
  no_summary: 'No summary',
  file: 'File',
  discover: 'Discover',
  discover_title: 'Discover',
  discover_hotChannels: 'Hot Channels',
  discover_allChannels: 'All',
  discover_searchChannel: 'Search channel',
  discover_noChannels: 'No channels found',

  // Messages
  operationSuccess: 'Operation successful',
  operationFailed: 'Operation failed',
  networkError: 'Network error, please try again later',
  dataLoadingFailed: 'Failed to load data',
  noData: 'No data',
  deleteConfirm: 'Are you sure you want to delete?',
  saveConfirm: 'Are you sure you want to save?',

  // Form Validation
  required: 'This field is required',
  emailInvalid: 'Please enter a valid email address',
  phoneInvalid: 'Please enter a valid phone number',
  passwordTooShort: 'Password must be at least {min} characters',
  passwordMismatch: 'Passwords do not match',

  // Time
  today: 'Today',
  yesterday: 'Yesterday',
  justNow: 'Just now',
  minutesAgo: '{min} minutes ago',
  hoursAgo: '{hour} hours ago',
  daysAgo: '{day} days ago',

  // Footer
  about: 'About',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Service',
  footerSupport: 'Support',

  // Register
  registerAgeConfirm: 'I confirm that I am at least 13 years old',
  registerAgeConfirm18: 'I confirm that I am at least 18 years old',
  registerTermsPrefix: 'I have read and agree to the ',
  registerTermsAnd: ' and ',
  registerAgeError: 'Please confirm your age',
  registerTermsError: 'Please accept the terms and privacy policy',

  // Chat
  chatPrivacyTip: 'Type your message in the hub and AI will first chat with you to clarify. Once you confirm, your message and AI summary are posted together and AI keeps finding matches.',
  aiChat_quickSuggestions: 'Try saying',
  aiChat_welcome: "Hey! Tell me what you're looking for.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Details understood — post to find your match',
  aiChat_readyToPostHint: 'Keep chatting to add details or update the summary anytime',
  aiChat_progressStep1: 'Understand details',
  aiChat_progressStep1Done: 'Details understood',
  aiChat_progressStep2: 'AI Summary',
  aiChat_progressStep2Desc: 'AI creates a summary for matching',
  aiChat_progressStep3: 'Post to Hub',
  aiChat_progressStep3Desc: 'Post and find your match',
  aiChat_publishExtraHint: 'Enter your message to the hub',
  aiChat_publishMsgRequired: 'Required',
  aiChat_publishMsgLabel: 'Your message to the hub',
  aiChat_matchSummaryLabel: "AI Summary",

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'The following content is AI-generated and for reference only.',
  aiChat_publishSuggestionHint: 'Tap to replace',
  aiChat_allowDirectContact: 'Allow Direct Contact',
  aiChat_allowDirectContactDesc: 'Others can contact you directly without matching',
  channel_chat_session_publishToChannel: 'Post to the Octo Hub',
  aiChat_newChat: 'Reset',

  // Channels / Hubs
  home_tabChannels: 'Octo Hubs',
  channels_title: 'Octo Hubs',
  channels_myChannels: 'Joined Hubs',
  channels_discover: 'Discover',
  channels_noChannels: 'No hubs yet',
  channels_noMyGroupsTitle: 'You haven\'t joined any hubs yet',
  channels_noMyGroupsSubtitle: 'Search for a hub to join and start connecting',
  channels_searchGroupsBtn: 'Search Hubs',
  channels_loginPrompt: 'Please login to view hubs',
  channels_create: 'Create Octo Hub',
  channels_search: 'Search Octo Hubs',
  channels_searchMyGroups: 'Search my Octo Hubs',
  channels_searchHint: 'Search',
  channels_searchHintChats: 'Search chats...',
  channels_searchHintGroups: 'Search hubs...',
  channels_searchHintMy: 'Search joined hubs...',
  channels_joinByCode: 'Join by Code',
  channels_joinByCodeTitle: 'Join Octo Hub by Code',
  channels_joinByCodeHint: 'Enter Octo Hub code',
  channels_joinByCodeConfirm: 'Join',
  channels_joinByCodeNotFound: 'Hub not found',
  channels_createNewGroup: 'Create new Octo Hub',
  channels_noResults: 'No hubs found',
  channel_detail_join: 'Join',
  channel_detail_leave: 'Leave',
  channel_detail_members: 'members',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} joined the hub',
  channelJoinMsg_twoJoined: '{name1} and {name2} joined the hub',
  channelJoinMsg_multiJoined: '{name1}, {name2} and {n} others joined the hub',
  channelJoinMsg_oneAndMoreJoined: '{name} and {n} others joined the hub',
  channelJoinMsg_membersJoined: '{n} members joined the hub',

  // Feed
  channels_feed: 'Chats',
  channels_groups: 'Hubs',
  feed_related: 'Related',
  feed_recommend: 'Recommend',
  feed_empty: 'No feed yet, explore hot hubs',
  feed_goToGroup: 'View in hub',
  feed_joinGroupAndSendMsg: 'Join a hub and send a msg',
  channel_detail_channelCode: 'Octo Hub Code',
  channel_detail_invitePhrase: 'You\'re invited to join "{name}"\nInvite code {code} — open the app to auto-join · AI clarifies first, then matches you with the right people',
  channel_detail_post: 'Post to Hub',
  channel_detail_aiHint: "Type your message in the hub and AI will clarify the details first",
  channel_input_hint: 'Say something...',
  channel_leave_confirm_message: 'Are you sure you want to leave this hub? You will no longer receive hub messages.',
  channel_invite_notFound: 'Hub not found or link has expired',
  channel_invite_joinBtn: 'Download OctoSay App',
  channel_invite_hint: 'Download the app, then scan this QR code or search the hub name to join',
  channel_invite_globalHintTitle: 'You are about to download the Global version',
  channel_invite_globalHintIOS: 'This app may not be available in China App Store. Please switch to a non-China Apple Store region and search for OctoSay, or download the APK directly below.',
  channel_invite_globalHintAndroid: 'Google Play may not be accessible in your region. We recommend downloading the APK directly, or try Google Play.',
  channel_invite_globalHintDefault: 'The app may not be available in your local app store. We recommend downloading the APK directly, or try the App Store.',
  channel_invite_globalBtnAppStore: 'Go to App Store',
  channel_invite_globalBtnGooglePlay: 'Go to Google Play',
  channel_invite_globalBtnAPK: 'Download APK Directly',
  channel_invite_defaultDesc: 'Join {name} on OctoSay',
  share: 'Share',
  share_channel: 'Share Hub',
  share_channel_link: 'Share Link',
  channel_detail_inviteCode: 'Invite code',
  channel_detail_copyLink: 'Copy Link',
  share_session_title: 'A post on OctoSay',
  share_match_title: 'A match on OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Check out {userName}\'s post on OctoSay',
  session_share_notFound: 'Post not found or link has expired',
  session_share_fromChannel: 'From Octo Hub',
  session_share_downloadBtn: 'Download OctoSay App',
  session_share_hint: 'Download the app to view the full post and join the hub',
  session_share_openInApp: 'Open in App',
  toast_link_copied: 'Link copied',
  toast_no_share_data: 'Nothing to share',
  channels_joinByQR: 'QR Code',
  channels_joinByQRWebHint: 'Web does not support QR scanning. Please enter the hub code to join.',
  channels_joinByQRTitle: 'Join by QR Code',
  channel_detail_qrCode: 'QR Code',
  channel_detail_qrCodeSave: 'Save Image',
  channel_detail_qrCodeSaveHint: 'Right-click the image to save',
  channel_detail_qrCodeSaved: 'Saved to album',
  channel_detail_qrCodeSaveFailed: 'Save failed, please try again',
  channel_detail_locateFailed: 'Failed to locate message',
  channel_detail_locateError: 'Error locating message',
  channel_detail_myMessages: 'My Messages',
  channel_detail_searchMessages: 'Search Messages',
  channel_detail_aiChat: 'AI Chat',
  channel_detail_matchHistory: 'Match History',
  channel_create_title: 'Create Octo Hub',
  channel_create_name: 'Octo Hub name',
  channel_create_description: 'Description',
  channel_create_submit: 'Create',
  channelCreate_aiAssist: 'AI will help you create a suitable hub',
  channelCreate_nameHint: 'Enter a name for your hub',
  channelCreate_descHint: 'Describe what your hub is about',
  channelCreate_creating: 'Creating...',
  channelCreate_created: 'Hub created!',
  channelCreate_failed: 'Failed to create hub',
  channelCreate_welcomeMsg: "Hi! I'm here to help you create a hub. Tell me what kind of hub you'd like — its topic or purpose — and I'll turn it into a hub name and intro, and generate an avatar for it.",
  channelCreate_aiHint: 'Write your hub topic...',
  channelCreate_clarifyingProgress: 'Organizing your hub topic...',
  channelCreate_readyToCreate: 'Ready to create Octo Hub',
  channelCreate_step1: 'Describe Topic',
  channelCreate_step1Done: 'Idea clarified',
  channelCreate_step2: 'Create Octo Hub',
  channelCreate_confirmBtn: 'Confirm Create',
  channelCreate_publicNotice: 'Hubs are public spaces for people with shared interests to gather and connect. The platform may manage, update, or merge hubs as needed. Feel free to share this hub with others who might be interested.',
  channelCreate_similarGroupsTitle: 'Similar Octo Hubs Found',
  channelCreate_similarGroupsDesc: 'These hubs might match what you want',
  channelCreate_exactMatchHint: 'A hub with this exact name already exists!',
  channelCreate_joinHint: 'These existing hubs might be a good fit',
  channelCreate_joinExisting: 'Join Existing Octo Hub',
  channelCreate_stillCreate: 'Still Create New Octo Hub',
  channel_chat_session_comments: 'Comments',
  channel_chat_session_commentHint: 'Write a comment...',
  channel_chat_session_sendComment: 'Comment',
  channel_chat_session_loadMore: 'Load more',
  channel_chat_session_noComments: 'No comments yet',
  channel_chat_session_deleteComment: 'Delete',
  channelSearch_title: 'Search in Hub',
  channelSearch_placeholder: 'Search messages...',
  channelSearch_onlyMine: 'Only my posts',
  channelSearch_tabAllMessages: 'Hub Messages',
  channelSearch_tabMyMessages: 'My Messages',
  chatMsgSearch_placeholder: 'Search messages',
  chatMsgSearch_tabMsgs: 'Messages',
  chatMsgSearch_tabContacts: 'Contacts',
  chatMsgSearch_emptyPrompt: 'Type keywords to search messages',
  chatMsgSearch_tooShort: 'Type at least 2 characters to search',
  chatMsgSearch_contactEmptyPrompt: 'Type a username or email to search contacts',
  chatMsgSearch_noContacts: 'No matching contacts',
  chatMsgSearch_inChatPlaceholder: 'Search in this chat',
  channelHistory_title: 'History',
  channelHistory_myMessages: 'My Messages',
  channelHistory_loadMore: 'Load more',
  channel_settings_push: 'Octo Hub Notifications',
  channel_settings_commentPush: 'Comment Notifications',
  channel_settings_likePush: 'Like Notifications',
  channel_settings_receiveNotifications: 'Receive Notifications',
  channel_settings_directContact: 'Allow Direct Contact',
  session_published: 'Published',
  session_publishFailed: 'Publish failed',
  session_setDirectContactSuccess: 'Setting saved',
  session_setDirectContactFailed: 'Failed to save setting',
  session_setPrivate: 'Set to Private',
  session_setPublic: 'Set to Public',
  session_pauseMatching: 'Pause matching',
  session_resumeMatching: 'Resume matching',
  session_matchPausedToast: 'Matching paused',
  session_matchResumedToast: 'Matching resumed',
  match_matchingPausedTitle: 'Matching is paused',
  match_reasonTag: 'Match reason',
  match_matchingPausedHint: 'Turn matching back on anytime.',
  session_confirmSetPrivate: 'Set this content to private? Other users will not be able to view it.',
  session_messageIsPrivate: 'This message is private',
  chatSessionComment_replyHint: 'Write a comment...',
  chatSessionComment_reply: 'Comment',
  chatSessionComment_count: '{n} comment | {n} comments',
  chatSessionMatch_count: '{n} match | {n} matches',
  chatSessionComment_replyTo: 'Reply',
  chatSessionComment_inputHint: 'Write a comment...',
  chatSessionComment_send: 'Send',
  chatSessionComment_delete: 'Delete',
  chatSessionComment_deleteConfirm: 'Are you sure you want to delete this comment?',
  chatSessionComment_loadMore: 'Load more',
  chatSessionComment_noMore: 'No more comments',
  chatSessionComment_loginToComment: 'Please login to comment',
  chatSessionComment_viewEarlier: 'View earlier {n} replies',
  chatSessionLike_like: 'Like',
  chatSessionLike_liked: 'Liked',
  chatSessionLike_count: 'likes',
  chatSessionBookmark_bookmark: 'Bookmark',
  chatSessionBookmark_bookmarked: 'Bookmarked',
  chatSessionMatch_viewMatches: 'View Matches',
  chatSessionMatch_matchHistory: 'Match History',
  chatSessionMatch_noMatches: 'No matches yet',
  channel_match_achievement: '{count} posts successfully matched',
  channel_match_achievement_view: 'View →',
  channel_matchHistory_title: 'Channel Match History',
  chatSessionMatch_matchedAt: 'Matched at {time}',
  discover_userMsgLabel: 'User said',
  common_loading: 'Loading...',
  common_sending: 'Sending...',
  common_error: 'Error',
  common_success: 'Success',
  common_me: 'Me',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "The AI is clarifying your need so your message actually works — once posted, it keeps matching for you",
  aiChat_clarifyingAlmostDone: 'Almost there, please confirm',
  aiChat_clarifyingOneMore: 'About 1 more question to go, then you can post',
  aiChat_clarifyingRemaining: 'About {count} more rounds to go, almost there',
  aiChat_clarifyingEvaluating: 'Evaluating progress...',
  aiChat_setPublicMatch: 'Set Public & Match',
  aiChat_needsClarifiedPublic: "I get you now. Once you confirm and post, AI will keep matching for you.\nFeel free to share more details anytime.",
  aiChat_needsClarifiedPrivate: 'Got it! Set public & let me keep finding matches for you!\nFeel free to tell me more details any time.',
  aiChat_setPublicTitle: 'Set Public',
  aiChat_setPublicMessage: 'Your content will be visible to others so OctoSay can find complementary matches for you.\n\nInformation that will be shared:\n• Your username and avatar\n• Your content summary\n• Conversation content (visible in Discover)\n\nYou can set it back to Private anytime.',
  aiChat_findMatches: 'View Match Result',
  aiChat_publishing: 'Publishing...',
  aiChat_matchSectionTitle: 'Your message fits these hubs best — tap one to post',
  aiChat_joinedBadge: 'Joined',
  aiChat_matchSectionEmpty: 'No strong matches yet — you can create a new hub and post there',
  aiChat_suggestPublishCreateNew: 'Create a New Hub',
  aiChat_repickChannel: 'Change hub',
  aiChat_creatingChannelTitle: 'No matching hub found — creating one for you',
  aiChat_creatingChannelHint: 'AI is creating a hub for your request — publishing comes right after, usually 10–30 seconds',
  aiChat_publishToChannelHint: 'Will be posted to "{name}"',
  aiChat_pickChannelTitle: 'Choose a hub to post to',
  aiChat_matchingChannelTitle: 'Finding the right hub for you',
  aiChat_matchingChannelHint: 'AI is searching based on your request — usually a few seconds to half a minute',
  aiChat_matchUnavailableTitle: 'Recommendations unavailable',
  aiChat_matchUnavailableHint: 'Search for a hub below, or close and reopen publishing to try again',
  aiChat_waitSlowHint: 'Still matching — just a little longer, or search for a hub below',
  aiChat_creatingSlowHint: 'Still creating your hub — just a little longer; you\'ll go straight to publishing once it\'s ready',
  aiChat_pickChannelEmptyHint: 'No matching hubs found. Create a new hub to post your message',
  aiChat_loadMore: 'Load More',
  sidebar_publish: 'New Post',
  chat_selectLocationOnMap: 'Please select a location on the map',

  // App.vue new
  placeholder_email: 'Please enter email',
  placeholder_mobile: 'Please enter mobile number',
  placeholder_password: 'Please enter password',
  placeholder_name: 'Please enter your name',
  random_nickname: 'Random',
  placeholder_verification_code: 'Please enter verification code',
  sending: 'Sending...',
  registering: 'Registering...',
  send_code: 'Send Code',
  retry_in_seconds: 'Retry in {countdown}s',
  toast_enter_email: 'Please enter email',
  toast_enter_mobile: 'Please enter mobile number',
  toast_invalid_email: 'Please enter valid email format',
  toast_invalid_mobile: 'Please enter valid mobile number',
  toast_send_code_failed: 'Failed to send verification code',
  toast_code_sent: 'Verification code sent to email',
  toast_code_sent_sms: 'Verification code sent to mobile',
  toast_send_code_error: 'Failed to send verification code, please try again later',
  toast_fill_all_fields: 'Please fill in all fields',
  toast_login_failed: 'Login failed',
  toast_login_success: 'Login successful',
  oauthOr: 'or',
  toast_oauth_login_failed: 'Google login failed',
  toast_oauth_login_error: 'Google login error, please try again',
  toast_login_error: 'Login failed, please try again later',
  toast_register_failed: 'Registration failed',
  toast_register_success: 'Registration successful',
  toast_register_error: 'Registration failed, please try again later',

  // AdBanner.vue
  ad: 'Ad',

  // ContactAdGate.vue
  contactAd_gateTitle: 'Before you connect',
  contactAd_gateSubtitle: 'This brief pause keeps OctoSay free — thanks for the support!',
  contactAd_waitBtn: 'Continue in {sec}s',
  contactAd_continueBtn: 'Continue to chat',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Chat',

  // AiMatch.vue
  ai_welcome_msg: 'Hi, I\'m AI. Tell me what\'s on your mind — a ride, a partner, a skill swap, or ANYTHING.',
  default_username: 'User',

  // AvatarCropDialog.vue
  crop_hint: 'Pinch to zoom, drag to adjust',
  toast_crop_failed: 'Failed to crop image',

  // ChatBox.vue
  loading_match_info: 'Loading match info...',
  view_match_details: 'View match details',
  step_clarify_needs: 'Clarify',
  step_ai_matching: 'Post to Hub',
  step_connect: 'AI Match',
  make_private: 'Make Private',
  setting: 'Setting...',
  action_photo: 'Photo',
  action_file: 'File',
  action_video: 'Video',
  action_location: 'Location',
  finding_matches: 'Finding Matches',
  hint_get_app: 'Get the app to keep connected',
  match_finding_title: 'Your Matches',
  match_finding_subtitle: 'AI is continuously matching for you',
  match_time_hint: 'This process usually takes 1-2 minutes',
  match_result_stats: 'Found {matched} best match{matchedPlural}{interested}',
  match_tap_to_connect: 'Tap to start your conversation',
  match_channel_hint: 'Matching in hub <strong>#{channel}</strong>. Prioritizing same-hub matches, but may include other hubs when needed.',
  label_perfect_match: 'Best Match',
  label_worth_a_look: 'Worth A Look',
  match_no_result_title: 'Still matching for you',
  match_no_result_desc: 'Share more details to help OctoSay keep finding the right matches. Please install app to get notified when someone matches with you.',
  go_back: 'Go Back',
  no_public_requirements: 'No public posts yet',
  channelEmpty_title: "It's quiet here",
  channelEmpty_subtitle: 'Be the first to share your thoughts',
  channelEmpty_hint: "Write down your thoughts and AI will help clarify them and keep matching, so your message never sinks",
  channelEmpty_action: 'Share your thoughts',
  stay_connected: 'Stay Connected',
  download_app_desc: 'Get the App to chat and receive notifications instantly when someone connects you!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'Direct APK',
  match_history: 'Match History',
  no_match_history: 'No match history yet',
  finding_matches: 'AI keeps finding matches for you - After posting a message to a hub',
  discover_connect_hint: 'You can chat with them once matched!',
  match_initializing: 'Initializing...',
  placeholder_login_to_chat: 'please login to tell me what\'s on your mind',
  toast_need_clear: 'Your thoughts are clear!',
  toast_ai_responding: 'AI is responding, please wait...',
  toast_uploading_image: 'Uploading image, please wait...',
  toast_uploading_file: 'Uploading file, please wait...',
  toast_max_photos: 'Max {max} photos allowed',
  toast_uploading: 'Uploading, please wait...',
  toast_file_too_large: '{name} exceeds 5MB limit',
  toast_video_too_large: '{name} exceeds 20MB limit',
  toast_video_processing: 'Video is being processed, please wait...',
  toast_upload_failed: 'Upload failed, please try again',
  toast_upload_link_failed: 'Upload link failed',
  analyzing_image: 'Analyzing image...',
  toast_location_confirmed: 'Location confirmed',
  toast_location_selected: 'Location selected',
  toast_enter_search: 'Please enter search content',
  toast_search_failed: 'Search failed',
  toast_no_locations: 'No locations found',
  toast_search_error: 'Search failed, please try again',
  toast_located_at: 'Located at: {address}',
  toast_shared_finding: 'Shared! Finding matches...',
  toast_update_failed: 'Update failed',
  toast_set_private: 'Set to private',
  toast_no_matches: 'No matches found',
  toast_matches_found: 'Found {count} best match{countPlural}',
  toast_start_conversation_first: 'Please start a conversation first',
  toast_load_history_failed: 'Failed to load match history',
  toast_ai_timeout: 'AI timed out, please try again',
  toast_message_blocked: 'Message blocked',
  network_disconnected: 'Network disconnected',
  toast_publish_success: 'Posted to hub!',
  toast_publish_failed: 'Failed to post to hub',

  // ChatMsgList.vue
  collapse_thinking: 'collapse thinking',
  expand_thinking: 'expand thinking',
  thinking: 'thinking',
  select_date: 'Select Date',
  selected_location: 'Selected Location',
  msg_blocked: 'Blocked',
  retry: 'Retry',
  msg_read: 'Read',
  msg_sent: 'Sent',
  msg_unread: 'Unread',
  label_start_datetime: 'Start Date & Time:',
  label_end_datetime: 'End Date & Time:',
  toast_select_start_datetime: 'Please select a start date and time',
  toast_end_before_start: 'End date-time cannot be earlier than start date-time',
  report_message: 'Report Message',
  block_user: 'Block User',
  msg_revoke: 'Recall',
  msg_quote: 'Quote',
  msg_revoked_self: 'You recalled a message',
  msg_revoked_other: 'The other party recalled a message',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Message recalled',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'The platform recalled this message due to a violation',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Message recalled',
  toast_revoke_failed: 'Failed to recall message',
  toast_load_data_failed: 'Failed to load data, please refresh.',
  toast_file_url_missing: 'File URL not found',
  toast_block_success: 'User blocked successfully',
  toast_block_failed: 'Failed to block user',

  // ChatSession.vue
  no_more_records: 'no more records.',
  title_needs_clarified: 'Thoughts Clarified',
  title_clarifying: 'Clarifying Your Thoughts',
  title_public: 'Public',
  title_private: 'Private',
  badge_clarified: 'Clarified',
  badge_clarifying: 'Clarifying',
  badge_only_me: 'Only Me',
  badge_expired: 'Expired',
  title_expired: 'Expired',
  no_chat_history: 'No chat history',
  toast_load_sessions_failed: 'Failed to load chat sessions: {msg}',
  toast_load_sessions_error: 'Failed to load chat sessions. Please refresh and try again.',

  // ContactMethods.vue
  block_status_banner: 'You have blocked this user',
  unblock_user: 'Unblock User',
  toast_block_missing_id: 'Cannot block user: missing user ID',
  dialog_block_confirm: 'Are you sure you want to block {name}? You won\'t receive any messages from them.',
  toast_user_blocked: '{name} has been blocked',
  toast_unblock_missing_id: 'Cannot unblock user: missing user ID',
  toast_user_unblocked: '{name} has been unblocked',

  // BlockedUsers.vue
  blocked_users: 'Blocked Users',
  blocked_users_empty: 'No blocked users',
  blocked_users_empty_hint: 'Blocked users can no longer send you messages',
  blocked_users_unblock: 'Unblock',
  dialog_unblock_confirm: 'After unblocking, they will be able to send you messages again.',
  toast_unblock_success: 'Unblocked',
  toast_unblock_failed: 'Failed to unblock, please try again',
  blocked_users_load_failed: 'Failed to load. Tap to retry',
  blocked_users_blocked_at: 'Blocked {date}',
  blocked_users_unknown_user: 'Unknown user',

  // Contacts.vue
  no_connections: 'No messages yet',
  chat_with: 'Chat with {name}',
  toast_load_contacts_failed: 'Failed to load connections: {msg}',
  toast_load_contacts_error: 'Failed to load connections. Please refresh and try again.',
  time_just_now: 'Just now',
  time_minutes_ago: '{min}m ago',
  time_hours_ago: '{hour}h ago',
  time_days_ago: '{day}d ago',

  // InteractionNotification.vue
  interaction_notification_title: 'Notifications',
  interaction_notification_subtitle: 'Comments & Likes',
  interaction_notification_empty: 'No notifications yet',
  interaction_notification_comment: 'commented: {content}',
  interaction_notification_like: 'liked your post',
  interaction_notification_reply: 'replied: {content}',
  interaction_notification_bookmark: 'bookmarked your post',
  toast_load_notifications_failed: 'Failed to load notifications: {msg}',
  toast_load_notifications_error: 'Failed to load notifications. Please refresh and try again.',
  mark_all_read: 'Mark all read',
  toast_mark_all_read_failed: 'Failed to mark all read, please try again',
  contacts_dnd: 'Mute Notifications',
  dnd_enabled: 'Notifications muted',
  dnd_disabled: 'Notifications unmuted',
  dnd_action_enable: 'Mute Notifications',
  dnd_action_disable: 'Unmute Notifications',

  // Discover.vue
  toast_load_sessions_failed: 'Failed to load sessions: {msg}',
  toast_load_sessions_error: 'Failed to load sessions',
  discover_noMessages: 'No messages yet',

  // EmojiInputArea.vue
  placeholder_default: 'Share more details with AI',
  userChat_typeMessage: 'Type a message...',
  select_emoji: 'Select Emoji',
  badge_new: 'new',
  channel_search_placeholder: 'Enter channel',
  channel_picker_empty: 'Enter channel',

  // FrontPage.vue
  tab_chat_with_ai: 'Let OctoSay Understand You',
  history_chats: 'History',
  tab_connections: 'Matches',
  tab_conversations: 'Messages',
  tab_profile: 'Profile',
  new_session: 'New',
  history_tab_chats: 'Mine',
  history_tab_matches: 'Matches',
  channels_octosay: 'Octo Hubs',
  tab_matches: 'Matches',
  tab_messages: 'Messages',

  // Header.vue
  slogan: 'OctoSay - AI that gets you, matches you.',
  app_name: 'OctoSay',
  slogan_short: 'AI that gets you, matches you.',
  slogan_ai: 'AI that gets you, matches you',
  get_the_app: 'Get the App',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'or search OctoSay in app stores',

  // MapLocationPicker.vue
  placeholder_search_location: 'Search location...',
  coords_display: 'Longitude: {lng}, Latitude: {lat}',
  toast_no_geolocation: 'Your browser does not support geolocation',
  toast_location_permission_denied: 'Unable to get your location, please check location permissions',
  loading_address: 'Loading address...',

  // MatchedSession.vue
  created_at: 'Created: {time}',
  ai_match_analysis: 'AI Match Analysis',
  error_missing_session_params: 'Missing required session parameters',
  match_private_hint: 'This session is private. Content is not available',

  // PersonalCenter.vue
  label_name: 'Name:',
  placeholder_enter_name: 'Enter your name',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Write something about yourself',
  placeholder_bio_empty: 'Say something about yourself',
  bio: 'Bio',
  delete_account: 'Delete Account',
  delete_warning: 'This action cannot be undone.',
  delete_data_intro: 'The following data will be permanently deleted:',
  delete_item_profile: 'Your profile information',
  delete_item_chat: 'Chat history and sessions',
  delete_item_contact: 'Contact information',
  delete_item_all: 'All associated data',
  final_confirmation: 'Final Confirmation',
  delete_confirm_prompt: 'Please type "delete" to confirm:',
  placeholder_type_delete: 'Type delete',
  private_token: 'Private Token',
  token_desc: 'Generate a token for API access',
  toast_not_logged_in: 'User not logged in',
  toast_name_required: 'Name is required',
  toast_save_success: 'Saved successfully',
  toast_save_failed: 'Save failed',
  toast_image_too_large: 'Image exceeds 5MB limit',
  toast_avatar_updated: 'Avatar updated',
  toast_avatar_failed: 'Failed to update avatar',
  toast_upload_failed: 'Upload failed',
  toast_token_generated: 'Token generated',
  toast_token_failed: 'Failed to generate token',
  toast_copied: 'Copied to clipboard',
  toast_copy_failed: 'Copy failed',
  toast_account_deleted: 'Account deleted successfully',
  toast_delete_account_failed: 'Failed to delete account',
  toast_logout_success: 'Logout successful',
  toast_logout_failed: 'Logout failed',
  profile_tab_messages: 'Messages',
  profile_tab_comments: 'Comments',
  profile_tab_likes: 'Likes',
  profile_tab_bookmarks: 'Bookmarks',
  profile_empty_messages: 'No messages yet',
  profile_empty_comments: 'No comments yet',
  profile_empty_likes: 'No likes yet',
  profile_empty_bookmarks: 'No bookmarks yet',
  profile_reply_to: 'Reply to {name}',
  profile_stats_posts: 'Messages',
  profile_stats_comments: 'Comments',
  profile_stats_likes: 'Likes Received',
  profile_joined: 'Joined {date}',

  // ReportDialog.vue
  report_message_title: 'Report Message',
  report_reason_prompt: 'Please select a reason for reporting this message:',
  report_spam: 'Spam',
  report_harassment: 'Harassment or bullying',
  report_inappropriate: 'Inappropriate content',
  report_other: 'Other',
  placeholder_report_desc: 'Please describe the issue (optional)',
  toast_select_reason: 'Please select a reason',
  toast_report_success: 'Report submitted successfully',
  toast_report_failed: 'Failed to submit report',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Image]',
  summary_images: '[Images x{count}]',
  summary_file: '[File]',
  summary_files: '[Files x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Videos x{count}]',
  summary_location: '[Location]',
  summary_locations: '[Locations x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emoji x{count}]',
  summary_voice: '[Voice]',
  summary_voices: '[Voices x{count}]',
  summary_mixed: '[Mixed]',
  summary_other: '[Other]',

  // Voice messages
  voice: 'Voice',
  voice_recording: 'Recording...',
  toast_voice_too_short: 'Recording too short',
  toast_voice_failed: 'Failed to send voice',
  toast_mic_permission_denied: 'Cannot access microphone. Please enable it in browser settings',
  toast_recording_not_supported: 'Voice recording is not supported in this browser',
  voice_load_failed: 'Failed to load voice message',

  // Expire At
  aiChat_expireLine: 'Valid until {date}, tell AI anytime to update',
  aiChat_expireExpired: 'Content has expired and is no longer visible to others. Tell AI anytime to update the expiration',

  // MatchedSession.vue
  detail: 'Detail',

  // Match notification hints
  match_new_result_hint: 'If there are new match results later, you will be notified by email. For a better experience, please install the app to receive instant notifications.',

  // Match notification hints
  match_connection_notify_hint: 'Match found and notified! Go say hi!',
  match_continuousMatching: 'AI is continuously matching for you',
  match_continuousMatchingHint: 'We\'ll let you know as soon as new matches are found',
  match_continuousMatchingOthers: 'AI is continuously matching for them',
  match_continuousMatchingOthersHint: 'New matches will appear here as they\'re found',
  match_noResultsTitleOthers: 'Still matching for them',
  match_noResultsHintOthers: 'AI is continuously matching for them. Results will appear here once found.',
  match_newMatchFound: '{n} new {n, plural, =1{match} other{matches}} found!',
  match_worth_exploring_hint: 'You decide whether to reach out.',

  // Matches filter tags
  filter_all: 'All',
  filter_best_connection: 'Best Match',
  filter_worth_a_look: 'Worth A Look',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - AI that gets you, matches you.',
  landing_hero_title: 'Write in your hub — AI clarifies first, then you publish and get matched.',
  landing_hero_subtitle: 'Type the message you want to share in an Octo Hub. Before it goes live, AI will chat with you to nail down the details. Once you confirm, your message and AI summary are posted together, and AI starts matching.',
  landing_download_on: 'Download on the',
  landing_get_it_on: 'Get it on',
  landing_direct_download: 'Direct Download',
  landing_how_title: 'How It Works',
  landing_step1_title: 'Write in the Hub',
  landing_step1_desc: 'Type the message you\'d like to share in the hub. AI will first chat with you to clarify the details, so every post is clear, useful, and ready for matching — not lost in noise.',
  landing_step2_title: 'Confirm, Post & Get Matched',
  landing_step2_desc: 'When you confirm, your original message and AI summary are posted to the hub together. AI then continuously finds your best matches, so your msg doesn\'t get buried or ignored.',
  landing_step3_title: 'Connect & Chat',
  landing_step3_desc: 'When a match is found, both sides can see each other\'s chat history with AI and the AI summary. With shared context, breaking the ice is easy — just chat naturally.',
  // Comparison Section
  landing_comparison_title: 'Why OctoSay?',
  landing_comparison_subtitle: 'Hub chat, but AI clarifies your details and actively matches you.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Content Quality',
  landing_cmp1_other: 'Spam, ads, off-topic floods',
  landing_cmp1_octo: 'AI-curated need cards only',
  landing_cmp2_label: 'Finding People',
  landing_cmp2_other: 'Post and just wait for replies',
  landing_cmp2_octo: 'AI actively matches you',
  landing_cmp3_label: 'Noise Level',
  landing_cmp3_other: 'Hundreds of messages to scroll',
  landing_cmp3_octo: 'Zero noise, every post matters',
  landing_cmp4_label: 'Getting Started',
  landing_cmp4_other: 'Find server, browse channels, figure it out',
  landing_cmp4_octo: 'Type in the hub; AI clarifies and matches',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Group chats flooded with ads & spam',
  landing_cmp1_xhs: 'Marketing posts everywhere, hard to trust',
  landing_cmp1_facebook: 'Ads and clickbait flood your feed',
  landing_cmp1_reddit: 'Spam and off-topic posts everywhere',
  landing_cmp2_wechat: 'Only through contacts and group invites',
  landing_cmp2_xhs: 'Search yourself and dig through posts',
  landing_cmp2_facebook: 'Limited to your existing friends & groups',
  landing_cmp2_reddit: 'Browse subreddits yourself, hope for replies',
  landing_cmp3_wechat: 'Scrolling hundreds of group messages',
  landing_cmp3_xhs: 'Feed full of recommendations and ads',
  landing_cmp3_facebook: 'Endless recommended posts & ads',
  landing_cmp3_reddit: 'Hundreds of comments to scroll',
  landing_cmp5_label: 'Who Does the Searching',
  landing_cmp5_wechat: 'Ask people one by one, hope for luck',
  landing_cmp5_xhs: 'Post, wait for comments, filter yourself',
  landing_cmp5_facebook: 'You have to ask around in groups',
  landing_cmp5_reddit: 'Post, wait for replies, then filter',
  landing_cmp5_octo: 'AI keeps finding people for you, automatically',

  landing_features_title: 'Core Features',
  landing_feature1_title: 'Clarify Before Posting',
  landing_feature1_desc: 'No forms to fill out. Type your message in the hub and AI will chat with you first to ask the right questions and truly understand your needs.',
  landing_feature2_title: 'Clean, Not Chaotic',
  landing_feature2_desc: "Your message and AI summary are posted together — OctoSay curates every post, so no spam, no off-topic floods, no scrolling through noise.",
  landing_feature3_title: 'Proactive Matching',
  landing_feature3_desc: "Once you confirm and your message + AI summary are live, AI continuously scans the hub to find people who fit what you're looking for — and explains why.",
  landing_feature4_title: 'Topic Communities, Zero Noise',
  landing_feature4_desc: 'Join topic hubs — sports, gaming, language exchange, roommates — AI clarifies your message before posting, so every hub stays clean and useful.',
  landing_feature5_title: 'Privacy Protected',
  landing_feature5_desc: 'You can set messages to private after sending, visible only to you. Full control.',
  landing_feature6_title: 'Meaningful Conversations',
  landing_feature6_desc: 'No noise, no cluttered distractions—every message matters.',
  landing_usecases_title: 'Works for Any Scenario',
  landing_usecases_subtitle: "Whatever's on your mind, join a topic hub — AI handles the matching so you don't have to scroll and search",
  landing_usecase_game: 'Gaming Buddy',
  landing_usecase_language: 'Language Exchange',
  landing_usecase_skill: 'Skill Swap',
  landing_usecase_roommate: 'Find Roommate',
  landing_usecase_travel: 'Travel Buddy',
  landing_usecase_sports: 'Sports Partner',
  landing_usecase_study: 'Study Partner',
  landing_usecase_anything: '...or share anything',
  landing_cta_title: 'Ready to Start?',
  landing_cta_desc: "Join a topic hub, write what you want to share, let AI clarify the details, then publish and get matched with the right people.",
  landing_use_now: 'Use Now',
  landing_groups: 'Hubs',

  // OnboardingPage.vue
  onboarding_skip: 'Skip',
  onboarding_next: 'Next',
  onboarding_getStarted: 'Start Using',
  onboarding_step1Title: "Say What You Need in the Hub",
  onboarding_step1Desc: "Whatever you're looking for or want to do, just say it. The AI chats with you to clarify the details and turns your words into a clear need — so the right people get it at a glance.",
  onboarding_step2Title: 'Confirm, Post & Get Matched',
  onboarding_step2Desc: "Once your message is posted to the hub, the AI keeps finding your best matches — so it never gets buried or ignored.",
  onboarding_step3Title: 'Connect & Chat',
  onboarding_step3Desc: "Both sides can see each other's chat with the AI, so you already know what the other person needs. Breaking the ice is easy — just chat naturally.",

  // ChannelDetail.vue
  channel_image_limit: 'Max 1 image',

  // ChannelMembers.vue
  channel_members_empty: 'No members yet',
  channel_members_title: 'Members',
  channel_role_owner: 'Owner',
  channel_role_admin: 'Admin',
  channel_role_member: 'Member',

  // Settings.vue
  settings_language: 'Language',
  settings_language_followSystem: 'Follow System',

  // ChatBox.vue
  match_interested_suffix: ', {count} worth a look',

  // ChatBox.vue - AI match progress stages
  match_stage_fetch_chat: 'Fetching conversation',
  match_stage_query_expansion: 'Expanding queries',
  match_stage_semantic_search: 'Semantic search',
  match_stage_deep_search: 'Deep analysis',
  match_stage_rerank: 'Smart matching',
  match_stage_refining: 'Refining results',
  match_stage_fetch_details: 'Fetching details',

  // ChannelDetail.vue - image upload
  channel_select_image: 'Please select an image file',
  channel_image_upload_failed: 'Image upload failed, please try again',
  chatInput_channelSearchHint: "Search hubs",
}



// WEBPACK FOOTER //
// ./src/i18n/en.js